export default __webpack_public_path__ + "static/media/Lions.07d76274.png";